export const CATEGORY_DATA = [
  'SPORT',
  'CAR',
  'FASHION',
  'HOME_APPLICES',
  'FURNITURE',
  'OFFICE',
  'DRINK',
  'HOME',
  'ETC',
];
